/**
 * Application Configuration
 * 
 * This file is auto-generated based on environment variables.
 * Environment: amazonstaging
 * Do not edit this file directly.
 */

const config = {
  // Environment
  nodeEnv: 'amazonstaging',
  
  // API Configuration
  apiBaseUrl: 'https://api.campaignstudio.tv',
  axiosOrigin: 'https://ecs.campaignstudio.tv',
  
  // Socket.IO Configuration
  socketIoBaseUrl: 'https://api.campaignstudio.tv',
  
  // Storage Configuration
  s3BaseUrl: 'https://ecs-icast-staging-us-east-1.s3.us-east-1.amazonaws.com',
  cloudfrontBaseUrl: 'https://d1f9g1bz7u87sn.cloudfront.net',
  
  // Feature Flags
  features: {
    enableAnalytics: true,
    enableNotifications: true,
  },
  
  // Other Configuration
  defaultTimezone: 'UTC',
  defaultLanguage: 'en',
  itemsPerPage: 10,
};

export default config;
